import React from 'react';

const PhilosophySection = () => {
  const philosophies = [
    {
      char: '明',
      title: '明於覺察',
      description: '進而掌控人生劇本'
    },
    {
      char: '悅',
      title: '悅於童心',
      description: '活出富而喜悅文化'
    },
    {
      char: '心',
      title: '心為本源',
      description: '滋養身心豐盛擴容'
    },
    {
      char: '創',
      title: '創於行動',
      description: '驅動全球創新影響'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-yellow-50 via-orange-50 to-red-50">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-red-500 mb-8">
              明悅心創
            </h2>
            <p className="text-2xl text-gray-700 leading-relaxed max-w-4xl mx-auto">
              以遊戲化學習（Game-based Learning）為引，<br />
              點亮內在高能動性（High Agency），<br />
              陪伴每一個生命從心開創「富而喜悅」的無限可能。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
            {philosophies.map((item, index) => (
              <div 
                key={index}
                className="group relative"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-orange-400 to-red-400 rounded-2xl opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
                <div className="relative bg-white rounded-2xl p-8 text-center hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
                  <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-gradient-to-br from-orange-400 to-red-400 flex items-center justify-center">
                    <span className="text-4xl font-bold text-white">{item.char}</span>
                  </div>
                  <h4 className="text-xl font-bold text-gray-800 mb-2">{item.title}</h4>
                  <p className="text-gray-600">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;